import React from 'react'

const CircleIcon = () => {
  return (
    <svg
      data-testid="icon-circle"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.6068 9.39343C31.9996 10.7863 33.1045 12.4399 33.8584 14.2598C34.6122 16.0797 35.0002 18.0303 35.0002 20.0001C35.0002 21.9699 34.6122 23.9205 33.8584 25.7404C33.1045 27.5603 31.9996 29.2139 30.6068 30.6068C29.2139 31.9996 27.5603 33.1045 25.7404 33.8584C23.9205 34.6122 21.9699 35.0002 20.0001 35.0002C18.0303 35.0002 16.0797 34.6122 14.2598 33.8584C12.4399 33.1045 10.7863 31.9996 9.39343 30.6068C6.58036 27.7937 5 23.9784 5 20.0001C5 16.0218 6.58036 12.2065 9.39343 9.39343C12.2065 6.58036 16.0218 5 20.0001 5C23.9784 5 27.7937 6.58036 30.6068 9.39343"
        stroke="#6F7974"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { CircleIcon }
